import { render, staticRenderFns } from "./umatSuami.vue?vue&type=template&id=f398eee2&scoped=true&"
import script from "./umatSuami.vue?vue&type=script&lang=js&"
export * from "./umatSuami.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./umatSuami.vue?vue&type=style&index=1&id=f398eee2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f398eee2",
  null
  
)

export default component.exports